// @flow

import { postMessageToParent } from '../../../chatbot/utils/iframe'
import { MESSAGE_TYPE_TUNNEL_CHATBOT_EVENTS } from '../../../common/iframeMessageTypes'

import { CHATBOT_EVENTS } from '../types'

function registerListener (event: string): void {
  window.addEventListener(event, ({ detail }) => postMessageToParent({
    event: MESSAGE_TYPE_TUNNEL_CHATBOT_EVENTS,
    detail: { event, data: detail }
  }))
}

export function registerPostMessageEventListeners (): void {
  Object.values(CHATBOT_EVENTS).forEach(event => registerListener(String(event)))
}
